export const BlockLink = (props) => {
    const label = props.label;
    let values;
    switch (label) {
        case 'link-total':
            values = { name: props.legend }
            return (
                <div className="title-link">
                    <div className="name">{values.legend}</div>
                </div>
            )
        case 'link-date':
            values = { href: props.href, name: props.name, date: props.date }
            return (
                <a className="title-link" href={values.href} alt={values.name} title={values.name}>
                    <div className="code"><i className="fa fa-link"></i></div>
                    <div className="name">
                        <div>{values.name}</div>
                        <div>{values.date}</div>
                    </div>
                </a>
            )
        case 'link-true':
        case 'link-jumba-jookiba':
            values = { href: props.href, name: props.name }
            return (
                <a className="title-link" href={values.href} alt={values.name} title={values.name}>
                    <div className="code"><i className="fa fa-link"></i></div>
                    <div className="name">{values.name}</div>
                </a>
            )
        default:
            return (
                <></>
            )
    }
}